function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { useContext } from 'react';
import proptypes from 'prop-types';
const {
  element,
  shape
} = proptypes;
import { ImpressionContext } from './ImpressionContext.js';
const ImpressionProvider = _ref => {
  let {
    children,
    data,
    additionalData
  } = _ref;
  // parentCtx below is going to either be the first provider in the tree
  // else this is not going to be the first provider
  const parentCtx = useContext(ImpressionContext); // <--Change name of parentCTX to something else
  const parent = parentCtx.data;
  const ctx = _objectSpread(_objectSpread({}, parentCtx), {}, {
    parent,
    data,
    additionalData,
    clickID: `${data === null || data === void 0 ? void 0 : data.id}-${data === null || data === void 0 ? void 0 : data.name}`,
    attributes: {
      'data-adobe': `${data === null || data === void 0 ? void 0 : data.id}-${data === null || data === void 0 ? void 0 : data.name}`
    }
  });
  return /*#__PURE__*/React.createElement(ImpressionContext.Provider, {
    value: ctx
  }, children);
};
ImpressionProvider.displayName = 'ImpressionProvider';
ImpressionProvider.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  data: shape({}),
  children: element,
  additionalData: shape({})
};
ImpressionProvider.defaultProps = {
  data: {},
  children: null,
  additionalData: {}
};
export { ImpressionProvider };
//# sourceMappingURL=ImpressionProvider.js.map